define('glu/grid/manageColumns/manageColumnsMenu',['require','../../itemView','hbs!./manageColumnsMenu.hbs','../../util','../../dialog','../../locale'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./manageColumnsMenu.hbs'),
        util = require('../../util'),
        dialog = require('../../dialog'),
        locale = require('../../locale');

    return ItemView.extend({
        template: tmpl,

        className: 'grid-manage-columns-menu',

        ui: {
            '$checkboxes': 'input[type="checkbox"]'
        },

        events: {
            'click .js-update-columns': 'handleSave',
            'click .js-cancel': 'close',
            'change @ui.$checkboxes': 'handleCheckboxChange'
        },

        handleCheckboxChange: function(e) {
            var $target = this.$(e.target);

            // do not allow the user to hide the last visible column
            if (this.ui.$checkboxes.filter(':checked').length === 0) {
                $target.prop('checked', true);
                return;
            }

            var model = this.getModelFromCid($target.val());
            // if there is a filter on the column, prompt before removing
            if (model && !$target.is(':checked') && this.isFilterOnField(model.get('field'))) {
                dialog.confirm(locale.get('removeColumnMsg'), locale.get('removeConfirmTitle'), function(ok) {
                    if (!ok) {
                        $target.prop('checked', true);
                    }
                });
            }
        },

        onRender: function() {
            this.setTopPosition();
        },

        initialize: function() {
            this.filterProcessor = this.options.filterProcessor;
        },

        setTopPosition: function() {
            this.$el.css('top', this.options.topPosition);
        },

        getModelFromCid: function(cid) {
            return this.collection.find(function(model) {
                return cid === model.cid;
            });
        },

        isFilterOnField: function(field) {
            return this.filterProcessor && !util.isUndefined(this.filterProcessor.filters.findWhere({
                field: field
            }));
        },

        serializeData: function() {
            return {
                // add checked and cid data to json
                rows: this.collection.chain().map(function(model) {
                    var checked = util.isFunction(model.get('condition')) ? model.get('condition')(model.get('field'), model) : (model.get('condition') !== false);
                    return util.extend(model.toJSON(), {
                        cid: model.cid,
                        isChecked: checked
                    });
                    // remove columns that we can't edit
                }).reject(function(model) {
                    return model.disableRemove;
                    // sort alphabetically
                }).sortBy(function(model) {
                    return model.label || model.title;
                    // group data into sets of 6 so we can wrap it in .row markup
                }).groupBy(function(model, i) {
                    return Math.floor(i / 6);
                }).values().value()
            };
        },

        handleSave: function() {
            var columnsLastItemIndex = this.ui.$checkboxes.length - 1;

            util.each(this.ui.$checkboxes, function(el, index) {
                var $el = this.$(el),
                    model = this.getModelFromCid($el.val()),
                    showColumn = $el.prop('checked');

                if (model) {
                    model.set('condition', showColumn, {
                        //to prevent multiple grid re-rendering
                        silent: true
                    });

                    // remove filters on hidden columns
                    if (this.filterProcessor && !showColumn && model.has('field')) {
                        this.filterProcessor.removeFilters(model.get('field'));
                    }

                    if (index !== columnsLastItemIndex) {
                        return;
                    }

                    //need to trigger change condition only after last element.
                    this.collection.trigger('change:condition');
                }
            }, this);

            this.close();
        }
    });
});

